export { default as auth } from "./auth";

export const deepCopy = (object) => JSON.parse(JSON.stringify(object));

export const download = (fileOrUrl, fileName) => {
  if (typeof fileOrUrl !== "string") {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(fileOrUrl, fileName);
    } else {
      fileOrUrl = URL.createObjectURL(fileOrUrl);
    }
  }
  const a = document.createElement("a");
  a.href = fileOrUrl;
  a.target = "_blank";
  a.download = fileName || fileOrUrl.substring(fileOrUrl.lastIndexOf("/") + 1);
  a.click();
};

export const imagesLoader = (images, callback) => {
  let total = images.length;
  let completed = 0;
  images.map((src) => {
    let image = new Image();
    image.src = src;
    image.onload = () => {
      callback && callback(++completed / total === 1);
    };
    image.onerror = () => {
      console.error("TOOL Error imagesLoader:" + src);
      callback && callback(++completed / total === 1);
    };
  });
};

export const importAll = (requireContext, exclude) => {
  // https://webpack.js.org/guides/dependency-management/#requirecontext
  // you do not need `import item from './items/item'`
  // it will auto require all item from items file
  return requireContext.keys().reduce((all, path) => {
    const name = path.replace(/^.*\/(.*)\.\w+$/, "$1");
    if (!(exclude && exclude.includes(name))) {
      const value = requireContext(path);
      all[name] = value.default || value;
    }
    return all;
  }, {});
};

export const speedList = [
  255,
  240,
  224,
  208,
  192,
  176,
  160,
  146,
  132,
  118,
  100,
  90,
  76,
  62,
  48,
  34,
];

export const deviceName = {
  cyberblade: "CYBERBLADE",
  alice: "AM AFA",
  cb02: "LE SMOKING",
  cb03: "CYBERBOARD R3",
  cb04: "CYBERBOARD",
  cb05: "CYBERBOARD R5",
  cb06: "CYBERBOARD R6",
  cb_terminal: "TERMINAL",
  cb_tm_01: "CYBERBOARD TMALL 头号玩家",
  hatsu: "HATSU",
  "65les": "AM 65 LESS",
  "65les_r1": "AM 65 LESS R1",
  "65les_r2": "AM 65 LESS R2",
  cb_matrix: "CYBERBOARD MATRIX",
  am21: "AM Relic 80",
  am28: "AM RGB 65",
  am_28: "AM RGB 65",
  dr001: "Black Diamond 75",
  dr002: "PetBrick 65",
  "02": "charge",
  "03": "base",
  "00": "ASE",
  "01": "top",
  hhkb: "HHKB",
  dongle: "AM Sniper2.4",
  mouse: "Mouse",
  magnetkey: "Magnetkey",
};
